import React, { useEffect, useState } from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Container } from "semantic-ui-react";
import { useSelector } from "react-redux";
import useFirestoreDoc from "../../../app/hooks/useFirestoreDoc";
import { listenToDocFromFirestore } from "../../../app/firestore/firestoreService";
import {
  FIRESTORE_COMPANY_PROFILE_COLLECTION,
  FIRESTORE_FEATURED_COMPANY_LOGOS_COLLECTION,
  FIRESTORE_JOBS_COLLECTION,
  QUERY_CODES,
} from "../../../app/firestore/firestoreConstants";
import { useHistory } from "react-router-dom";
import {
  PAYMENT_COMPANY_LOGO_FEATURE_SERVICE,
  PAYMENT_COMPANY_PROFILE_SERVICE,
  PAYMENT_JOB_POST_SERVICE,
} from "../paymentConstants";
import card from "../../../assets/icons/credit-card.svg";
import bank from "../../../assets/icons/bank-account.svg";

export default function PromptPayModal({
  heading = "Pay now",
  hostedInvoiceUrl = "",
  paymentService,
  id = null,
}) {
  const history = useHistory();

  const { responsive } = useSelector((state) => state.app);

  const [item, setItem] = useState(null);

  useFirestoreDoc({
    shouldExecute:
      paymentService === PAYMENT_COMPANY_LOGO_FEATURE_SERVICE && id !== null,
    query: () =>
      listenToDocFromFirestore({
        dbCollection: FIRESTORE_FEATURED_COMPANY_LOGOS_COLLECTION,
        id: id,
      }),
    data: (service) => setItem(service),
    deps: [id],
    queryCode: QUERY_CODES.listenToFeaturedCompanyLogoFromFirestore,
  });

  useFirestoreDoc({
    shouldExecute: paymentService === PAYMENT_JOB_POST_SERVICE && id !== null,
    query: () =>
      listenToDocFromFirestore({
        dbCollection: FIRESTORE_JOBS_COLLECTION,
        id: id,
      }),
    data: (service) => setItem(service),
    deps: [id],
    queryCode: QUERY_CODES.listenToJobFromFirestore,
  });

  useFirestoreDoc({
    shouldExecute:
      paymentService === PAYMENT_COMPANY_PROFILE_SERVICE && id !== null,
    query: () =>
      listenToDocFromFirestore({
        dbCollection: FIRESTORE_COMPANY_PROFILE_COLLECTION,
        id: id,
      }),
    data: (service) => setItem(service),
    deps: [id],
    queryCode: QUERY_CODES.listenToCompanyProfileFromFirestore,
  });

  useEffect(() => {
    if (!item) return;
    if (item.isPaidFor) {
      history.push(`/payment-success/${paymentService}=paid`);
    }
  }, [history, item, paymentService]);

  return (
    <ModalWrapper
      size="tiny"
      style={{ width: !responsive.isMobile ? 400 : "98%" }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={200}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      isClose={true}
    >
      <div className="loading-modal">
        <Container textAlign="center">
          <div>
            <div className="modal-blue-text" style={{ fontSize: 20 }}>
              {heading}
            </div>
            <div className="modal-blue-text">
              <div>You’ll receive an invoice by email shortly.</div>
              <br />
              <div className={"display-flex"}>
                <img
                  src={card}
                  style={{ marginRight: 12, width: 30 }}
                  alt="card"
                />
                <span>
                  Pay by card:{" "}
                  <a
                    className="text-link"
                    href={hostedInvoiceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    click here
                  </a>
                </span>
              </div>
              <br />
              <div className={"display-flex"}>
                <img
                  src={bank}
                  style={{ marginRight: 12, width: 30 }}
                  alt="bank"
                />
                <span>
                  Pay by bank transfer: use the bank information provided on the
                  invoice.
                </span>
              </div>
              <br />
              <div>
                Services will appear under review when we receive payment.
              </div>
            </div>
          </div>
        </Container>
      </div>
    </ModalWrapper>
  );
}
